import React from 'react';
import {Button} from '@pepsico-ds/ui/Atoms';
import ActionMenu from '@/components/organisms/CustomDataTable/ActionMenu';

const ToolbarActionsRight = ({actions, actionMenuConfig}) => {
  const hasActions = actions && actions.length > 0;
  const hasActionMenu = !!actionMenuConfig;

  if (!hasActions && !hasActionMenu) return null;

  return (
    <div
      className='peacock-toolbar-right-actions'
      data-testid='toolbar-actions-right'>
      {hasActionMenu && <ActionMenu {...actionMenuConfig} />}
      {hasActions &&
        actions.map((action, idx) => (
          <Button
            key={idx}
            text={action.text}
            variant={action.variant || 'secondary'}
            size='medium'
            disabled={action.isDisabled}
            onClick={action.onClick}
          />
        ))}
    </div>
  );
};

export default ToolbarActionsRight;
